import React from 'react';

interface Props {
  modulo?: string;
  messaggio?: string;
}

export default function AccessoNegato({ messaggio }: Props) {
  return (
    <div className="bop-accesso-negato">
      <svg
        width="48" height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#cbd5e1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="bop-accesso-negato__icon"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <p className="bop-accesso-negato__title">
        Accesso non autorizzato
      </p>
      <p className="bop-accesso-negato__text">
        {messaggio ?? 'Non hai i permessi necessari per visualizzare questa sezione. Contatta un Superadmin.'}
      </p>
    </div>
  );
}
